import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './style.scss';
import NotificationCentreActions from '@Actions/configurations/notificationCentreActions';
import {
  Checkbox, Collapse, Skeleton, Table, Tooltip,
} from 'antd';
import { BorderBottomOutlined, InfoCircleOutlined } from '@ant-design/icons';
import H3Text from '@Uilib/h3Text';

const { Panel } = Collapse;

const NotificationCentre = ({
  getNotifications, getNotificationLoading, updateNotifications,
}) => {
  const [data, setData] = React.useState([]);
  const [call, setCall] = React.useState(false);

  useEffect(() => {
    getNotifications('', (newData) => setData(newData?.event_groups));
  }, [call]);

  const columns = [
    {
      title: 'Notifications Type',
      key: 'sub_events',
      width: '70%',
      render: (record) => (
        <div className="notification__type">
          {record?.event_name?.toProperCase()}
          {/* <Tooltip title={record?.event_info?.toProperCase()}>
            <InfoCircleOutlined
              style={{
                color: '#1890ff',
                fontSize: '12px',
                cursor: 'pointer',
                marginLeft: 4,
              }}
            />
          </Tooltip> */}
        </div>
      ),
    },
    {
      title: 'Enabled',
      dataIndex: 'sub_events',
      key: 'sub_events',
      width: '30%',
      render: (subEvents) => (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px' }}>
          {subEvents?.map((subEvent) => (
            <div key={subEvent?.event_id}>
              <Checkbox
                checked={subEvent?.event_value}
                onChange={() => {
                  const payload = {
                    subscribed_events: {
                      [subEvent.event_id]: !subEvent.event_value,
                    },
                    notify_name: subEvent?.channel_name,
                  };
                  updateNotifications(payload, () => {
                    setCall(!call);
                  });
                }}
              >
                {subEvent?.channel_name?.toProperCase()}
              </Checkbox>
            </div>
          ))}
        </div>
      ),
    },
  ];
  return (
    <div className="notification__container">
      {!data?.length ? (
        <div className="notification__no-data">
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
        </div>
      ) : (
        data?.map((eventGroup) => (
          <div key={eventGroup?.event_id} style={{ marginBottom: '30px' }}>
            <h5 className="notification__group-name">{eventGroup?.group_name?.toProperCase()}</h5>
            <H3Text
              text={eventGroup?.group_info?.toProperCase() || ''}
              className="notification__group-info"
            />
            <div className='show-table-header-in-mobile width-100-in-mobile'>
              <Table
                dataSource={eventGroup?.events}
                columns={columns}
                pagination={false}
                size="small"
                scroll={{x: true, y: false }}
                bordered={false}
                loading={getNotificationLoading}
              />
            </div>
          </div>
        ))
      )}
    </div>
  );
};

const mapStateToProps = ({
  UserReducers, NotificationCentreReducers,
}) => ({
  user: UserReducers.user,
  getNotificationSuccess: NotificationCentreReducers.getNotificationSuccess,
  getNotificationLoading: NotificationCentreReducers.getNotificationLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getNotifications: (payload, callback) => dispatch(NotificationCentreActions.getNotifications(payload, callback)),
  updateNotifications: (payload, callback) => dispatch(NotificationCentreActions.updateNotifications(payload, callback)),
});

NotificationCentre.propTypes = {
  getNotifications: PropTypes.func,
  getNotificationLoading: PropTypes.bool,
  updateNotifications: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(NotificationCentre));
